/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1610
 */

var r = require(/* 86 */"./1650/86/index")
var o = require(/* 1251 */"./1765/1251")
r({
  target: "Array",
  proto: true,
  forced: o !== [].lastIndexOf
}, {
  lastIndexOf: o
})
